<aside class="sidebar" [class.sidebar--collapsed]="collapsed" (mouseenter)="setCollapsed(false)" (mouseleave)="setCollapsed(true)">
  <a class="brand" routerLink="/dashboard">
    <img class="brand-mark" src="assets/images/favicons/mh-re-dsm.svg?v=4" alt="">
    <span>
      <strong>MH-RE DSM</strong>
      <small>Energy Portal</small>
    </span>
  </a>

  <nav class="menu" aria-label="Portal navigation">
    @for (item of menuItems(); track item.label) {
      @if (item.children.length > 0) {
        <div class="menu-group">
          @if (item.route !== '#') {
            <a
              [routerLink]="item.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
            >
              <span class="menu-icon">{{ item.icon }}</span>
              <span>{{ item.label }}</span>
            </a>
          } @else {
            <div class="menu-parent">
              <span class="menu-icon">{{ item.icon }}</span>
              <span>{{ item.label }}</span>
            </div>
          }
          <div class="submenu">
            @for (child of item.children; track child.route) {
              <a
                [routerLink]="child.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: child.route === '/dashboard' }"
              >
                <span class="menu-icon">{{ child.icon }}</span>
                <span>{{ child.label }}</span>
              </a>
            }
          </div>
        </div>
      } @else {
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
        >
          <span class="menu-icon">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </a>
      }
    } @empty {
      <div class="menu-empty">No menu assigned</div>
    }
  </nav>
</aside>
